import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_staff/settings/permission-and-roles/_detail',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
